export default __webpack_public_path__ + "static/media/Fuzzy_Nature.dfc5e886.mp3";